import Form from 'react-bootstrap/Form';

const ValueDisabled = ({ type, value }) => {
    const isNumeric = type === 'INTEGER' || type === 'DOUBLE';
    if (isNumeric) {
        return value;
    } else {
        const isChecked = value === 'true';
        return <Form.Check
            type="checkbox"
            checked={isChecked}
            disabled
        />;
    }
};

export default ValueDisabled;